<template>
  <div class="ui-detail" id="mbBody" ref="mbBody">
    <div class="title">
      <!-- <span class="border"></span> -->
      <span class="titleinfo">{{ $t("Product details") }}</span>
      <!-- <span class="border"></span> -->
    </div>
    <div>
      <desc-item
        :mbBody="detailInfo.photos"
        :detailInfo="detailInfo"
        v-if="detailInfo"
      ></desc-item>
    </div>
    <v-back-top v-if="isshowBacktop" :target="target"></v-back-top>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DescItem from "./DescItem";
import BackTop from "./DetailBackTop";
export default {
  data() {
    return {
      isshowBacktop: false,
    };
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },

  components: {
    "desc-item": DescItem,
    "v-back-top": BackTop,
  },

  computed: mapState({
    detailInfo: (state) => state.goodsdetail.detailInfo,
    mbBody: (state) => state.goodsdetail.mbBody,
  }),

  methods: {
    handleScroll() {
      let mbBodytop = this.$refs.mbBody.getBoundingClientRect().top;
      this.$emit("mbBodytop", mbBodytop);
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
};
</script>

<style lang="scss" scoped>
.ui-detail {
  margin: 0.5rem 0;
  min-height: 10rem;
  position: relative;

  .title {
    width: 120px;
    font-size: 0.8rem;
    margin-left: 12px;
    padding: 0.3rem 0px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-bottom: none; /* 取消默认下划线 */
    background-image: linear-gradient(
      90deg,
      #e8090c 30%,
      #f3611e 20%,
      RGBA(240, 240, 240, 1) 50%
    );
    background-size: 100% 5px; /* 下划线的高度 */
    background-repeat: no-repeat;
    background-position: bottom;
    .border {
      width: 3rem;
      height: 1px;
      background-color: #eee;
      margin: 0 0.5rem;
    }
  }
}
</style>
